<template>
  <video
    v-if="visible && !config.autoPlay"
    ref="videoRef"
    className="magic-ui-video"
    preload="none"
    webkit-playsinline="true"
    playsinline="true"
    x5-video-player-type="h5-page"
    :id="`${config.id || ''}`"
    :poster="config.poster"
    :src="src"
    :controls="config.controls"
    :loop="config.loop"
    :muted="config.muted"
    @play="emitEvent('play')"
    @ended="emitEvent('ended')"
    @pause="emitEvent('pause')"
    @waiting="emitEvent('waiting')"
  />
    <video
    v-else-if="visible && config.autoPlay"
    ref="videoRef"
    className="magic-ui-video"
    preload="none"
    webkit-playsinline="true"
    playsinline="true"
    x5-video-player-type="h5-page"
    :id="`${config.id || ''}`"
    :poster="config.poster"
    :src="src"
    :autoPlay="config.autoPlay"
    :controls="config.controls"
    :loop="config.loop"
    :muted="config.muted"
    @play="emitEvent('play')"
    @ended="emitEvent('ended')"
    @pause="emitEvent('pause')"
    @waiting="emitEvent('waiting')"
  />
</template>

<script lang="ts" setup>
import { watch, ref, reactive } from 'vue';
import { MComponent } from '@tmagic/schema';
import useApp from '@/hooks/useApp';
import useDisplay from '@/hooks/useDisplay';
import initValue from '../initValue';

const props = defineProps<{
  config: MComponent & typeof initValue;
}>();

const app = useApp(props);
const src = ref(props.config.src);
watch(() => props.config.src, (val: string) => {
src.value = val;
});


const node = app?.page?.getNode(props.config.id!);

const videoRef = ref<HTMLVideoElement>();

const emitEvent = (type: string) => {
console.log(`组件${props.config.id}的触发了video:${type}事件并广播`)
app?.emit(`video:${type}`, node)
}


const videoPlay = () => {
  videoRef.value?.play();
}
const videoPause =  () => {
  videoRef.value?.pause();
}
const setValue = (val) => {
  src.value = val;
}
const { visible, show, hide } = useDisplay(props);
// 暴露给编辑器的接口请注册在这里
const exportInterface = reactive({
  videoPause,
  videoPlay,
  setValue,
  value: src,
  show,
  hide,
});
defineExpose(exportInterface);
</script>
